<mat-card>
    <h2>Profil editieren</h2>
    <form #registerForm id="registerForm" (ngSubmit)="onSubmit()">
        <p>
            <mat-form-field color="accent">
                <mat-select name="salut" placeholder="Anrede" [formControl]="salutFormControl" required>
                    <mat-option value="Frau">Frau</mat-option>
                    <mat-option value="Herr">Herr</mat-option>
                </mat-select>
                <mat-error *ngIf="salutFormControl.hasError('required')">
                    Bitte wählen Sie ein Anrede
                </mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field color="accent">
                <input matInput type="text" name="given_name" placeholder="Vorname" [formControl]="givenNameFormControl"
                    required />
                <mat-error *ngIf="givenNameFormControl.hasError('required')">
                    Der Vorname ist erforderlich.
                </mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field color="accent">
                <input matInput type="text" name="family_name" placeholder="Nachname"
                    [formControl]="familyNameFormControl" required />
                <mat-error *ngIf="familyNameFormControl.hasError('required')">
                    Der Nachname ist erforderlich.
                </mat-error>
            </mat-form-field>
        </p>
        <p>
            <a class="lost-pw" routerLink="/willkommen">Zurück zur Übersicht</a>
            <button mat-flat-button color="accent" type="submit">Profil speichern</button>
        </p>
    </form>
</mat-card>